import { safeGetItem } from "./storage.js";

export type ThemeMode = "system" | "light" | "dark";

export const THEME_CYCLE: ThemeMode[] = ["system", "light", "dark"];
export const THEME_STORAGE_KEY = "argus-theme";

export const THEME_COLOR_LIGHT = "#faf7f4";
export const THEME_COLOR_DARK = "#121a12";

export function getCurrentTheme(): ThemeMode {
  const val = document.documentElement.getAttribute("data-theme");
  if (val === "light" || val === "dark") return val;
  return "system";
}

export function getStoredTheme(): ThemeMode {
  const stored = safeGetItem(THEME_STORAGE_KEY);
  return stored === "light" || stored === "dark" ? stored : "system";
}

export function applyThemeMode(mode: ThemeMode): void {
  if (mode === "system") {
    document.documentElement.removeAttribute("data-theme");
  } else {
    document.documentElement.setAttribute("data-theme", mode);
  }
  syncThemeColorMeta(mode);
}

export function initTheme(): void {
  applyThemeMode(getStoredTheme());
}

const OVERRIDE_META_SELECTOR = 'meta[name="theme-color"]:not([media])';

function syncThemeColorMeta(mode: ThemeMode): void {
  const existing = document.head.querySelector<HTMLMetaElement>(
    OVERRIDE_META_SELECTOR,
  );

  if (mode === "system") {
    existing?.remove();
    return;
  }

  const meta = existing ?? document.createElement("meta");
  meta.setAttribute("name", "theme-color");
  meta.setAttribute(
    "content",
    mode === "dark" ? THEME_COLOR_DARK : THEME_COLOR_LIGHT,
  );
  if (!existing) {
    document.head.prepend(meta);
  }
}
